import {StructuredDataContent} from 'rlink-repos/content';

export default class ImageItem extends StructuredDataContent {
  static get contentIcon () {
    return 'picture-o';
  }

  static defaultData () {
    return {
      imagePath: '',
    };
  }

  get adminLabel () {
    return this.title.length > 0 ? this.title : '<untitled image item>';
  }

  imageFormats () {
    return [this.mainImageFormats];
  }

  get mainImageFormats () {
    return {
      src: this.imagePath,
      formats: [
        {contentType: 'image/webp', fileExt: 'webp'},
        {contentType: 'image/jpeg', fileExt: 'jpg'},
      ],
      widths: [
        1920, 1680, 1366, 1024, 800, 568, 480, 420, 320,
      ],
    };
  }

  get imagePath () {
    return this.data.get('imagePath', this.constructor.defaultData().imagePath);
  }

  get linkedContentPaths () {
    return [this.imagePath];
  }

  get title () {
    return this.data.get('title', '');
  }

  get priority () {
    return this.data.get('priority', 0);
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-media/ImageItem.js